import React from 'react';
import { Switch, Route } from 'react-router-dom';

import * as Routes from './Routes';

import AuthProtectedRoute from './AuthProtectedRoute';
import AuthRedirectRoute from './AuthRedirectRoute';
import { ROUTES } from '../constants';

function SiteSwitch() {
  return (
    <Switch>
      <AuthRedirectRoute
        exact
        path={ROUTES.PATH.ORDER_TRACKING}
        component={Routes.OrderTracking}
      />
      <AuthProtectedRoute
        exact
        path={ROUTES.PATH.ONLINE_AUTH_RECEIPTS}
        component={Routes.OnlineReceipt}
      />
      <AuthProtectedRoute
        exact
        path={ROUTES.PATH.ORDER_HISTORY}
        component={Routes.OrderHistory}
      />
      <AuthProtectedRoute
        exact
        path={ROUTES.PATH.ORDER_HISTORY_CANCEL}
        component={Routes.OnlineCancel}
      />
      <AuthProtectedRoute
        exact
        path={ROUTES.PATH.ORDER_HISTORY_RETURNS}
        component={Routes.OnlineReturns}
      />
      <AuthProtectedRoute
        exact
        path={ROUTES.PATH.RATINGS_REVIEWS}
        component={Routes.RatingsReviews}
      />
      <AuthProtectedRoute
        exact
        path={ROUTES.PATH.ERECEIPTS_SUMMARY}
        component={Routes.eReceipts}
      />
      <Route
        exact
        path={ROUTES.PATH.ONLINE_ORDER}
        component={Routes.OnlineOrder}
      />
      <Route
        exact
        path={ROUTES.PATH.ONLINE_CANCEL}
        component={Routes.OnlineCancel}
      />
      <Route
        exact
        path={ROUTES.PATH.ONLINE_RETURNS}
        component={Routes.OnlineReturns}
      />
      <Route
        exact
        path={ROUTES.PATH.ONLINE_RECEIPTS}
        component={Routes.OnlineReceipt}
      />
      <Route
        exact
        path={ROUTES.PATH.GUEST_MA_CANCELLATION}
        component={Routes.ApplianceCancel}
      />
      <Route
        exact
        path={ROUTES.PATH.IN_STORE_ORDER}
        component={Routes.OnlineOrder}
      />
      <AuthProtectedRoute
        exact
        path={ROUTES.PATH.AUTH_IN_STORE_TRACKING}
        component={Routes.AuthInstoreOrder}
      />
      <AuthProtectedRoute
        exact
        path={ROUTES.PATH.AUTH_IN_STORE_ORDER}
        component={Routes.OnlineOrder}
      />
      {/* Any other route not found */}
      <Route component={Routes.PageNotFound} />
    </Switch>
  );
}

export default SiteSwitch;
